import AuthLayout from "@/layouts/AuthLayout";
import * as g from "@/apps/auth/router/guards";

export default {
  path: "/login",
  component: AuthLayout,
  children: [
    {
      path: "/",
      name: "Login",
      component: () => import("@/apps/auth/components/login"),
      props: true,
      beforeEnter: (to, from, next) => {
        g.ifNotAuthenticated(to, from, next);
      },
      meta: { name: "Авторизация" }
    },
    {
      path: "/logout",
      name: "Logout",
      component: () => import("@/apps/auth/components/Logout"),
      beforeEnter: (to, from, next) => {
        const prevRoute = from.name;

        prevRoute ? next() : next({ path: "/" });
      }
    }
  ]
};
